import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./PropertiesPanel.less');
const cx = classnames.bind(styles);

export class PropertiesPanel extends React.Component<any, any>
{
    public render():JSX.Element
    {
        return (
            <div className={cx('base')} data-component="property-panel">
                {this.props.children}
            </div>
        );
    }
}
